export function sendNativeMessage(data) {
  console.log('sending', data)

  const message = JSON.stringify(data)

  const isIOS = typeof window.webkit?.messageHandlers?.nativeAction?.postMessage === 'function'
  const isAndroid = typeof window.nativeAction?.postMessage === 'function'

  if (isIOS) {
    try {
      window.webkit.messageHandlers.nativeAction.postMessage(message)
      console.log('sent on ios')
    } catch (e) {
      console.log('failed to send on ios', e)
    }
  } else if (isAndroid) {
    try {
      window.nativeAction.postMessage(message)
      console.log('sent on android')
    } catch (e) {
      console.log('failed to send on android', e)
    }
  } else {
    console.log('no native bridge detected')
  }

  console.log('done sending', data)
}

window.sendNativeMessage = sendNativeMessage
